import { render, staticRenderFns } from "./MainContainerMobile.vue?vue&type=template&id=80094458&scoped=true&"
import script from "./MainContainerMobile.vue?vue&type=script&lang=js&"
export * from "./MainContainerMobile.vue?vue&type=script&lang=js&"
import style0 from "./MainContainerMobile.vue?vue&type=style&index=0&id=80094458&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80094458",
  null
  
)

export default component.exports